@use 'vars';

$ICON_SIZE: 40px;

.menu-item {
  display: flex;
  align-items: center;
  gap: vars.$gap-medium;
  text-align: left;
  background: transparent;
  border: none;

  &:hover {
    cursor: pointer;

    .menu-item__content__arrow-container {
      margin-right: -(vars.$gap-xsmall);
    }
  }

  &__content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    gap: vars.$gap-xsmall;
  }

  &__text {
    display: flex;
    flex-direction: column;
    gap: vars.$gap-xsmall;
  }

  &__content__arrow-container {
    display: none;
  }

  &__text__description {
    font-size: vars.$font-size-small;
    color: vars.$dark-grey;
  }

  // compact specific styles
  &--compact {
    padding: vars.$padding-small 0;
    transition:
      vars.$slide-right,
      0.3s padding-left ease;
    gap: vars.$gap-small;

    &:first-child {
      padding-top: vars.$padding-xsmall !important;
    }

    &__text__description {
      font-size: vars.$font-size-extra-small;
    }

    &:hover {
      padding-left: vars.$padding-xsmall;
    }
  }

  // comfortable specific styles
  &--comfortable {
    padding: vars.$padding-small 0;
    transition:
      vars.$slide-right,
      0.3s padding-left ease;
    gap: vars.$gap-small;

    @media screen and (min-width: vars.$softphone-max-width) {
      padding: vars.$padding-medium;
    }

    &:first-child {
      padding-top: vars.$padding-xsmall !important;
    }

    &__text__description {
      font-size: vars.$font-size-extra-small;
    }

    &:hover {
      padding-left: vars.$padding-xsmall;
    }
  }

  // stand alone specific styles
  &--stand_alone {
    border-radius: 8px; //requested to drop from 12 to 8 which we do not have as part of our vars
    border: vars.$border-size-thin solid vars.$ai-primary;
    padding: vars.$padding-small;
    box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);

    &__content__arrow-container {
      display: block;
      transition: margin-right 0.2s ease-in-out;
    }

    &__icon {
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: vars.$ai-secondary;
      border-radius: vars.$border-radius-xlarge;
      min-width: $ICON_SIZE;
      width: $ICON_SIZE;
      min-height: $ICON_SIZE;
      height: $ICON_SIZE;
    }

    &:hover {
      cursor: pointer;
    }
  }
}
